import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const propTypes = {
	intl: PropTypes.func,
	userData: PropTypes.object,
	loginWithAdmin: PropTypes.func
};

const LoginAdmin = ({
	intl,
	userData,
	loginWithAdmin
}) => (
	<div className="login-with-admin">
		{ userData['general']['is_from_admin'] && (
			<a
				className="admin-logout-link"
				onClick={() => loginWithAdmin()}>
				<span>{ intl(userData.general['source_page']['title']) }</span>
			</a>
		) }
	</div>
);

LoginAdmin.propTypes = propTypes;
export default connect(
	state => ({
		userData: state.app.userData
	})
)(LoginAdmin);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/sidebar/login-admin/main.js